'use strict';

import template from './not_found.html';

const saNotFound = [
  function () {
    return {
      template: template,
      replace: true
    };
  }
];

export default saNotFound;



// WEBPACK FOOTER //
// ./app/src/directives/not_found.js